import configCommon from "./config.common.json";
import configDevelop from "./config.develop.json";
import configRecette from "./config.recette.json";
import configStaging from "./config.staging.json";
import configProd from "./config.prod.json";

let conf;

switch (process.env.NODE_ENV) {
  case "development":
  case "develop":
    conf = { ...configDevelop, ...configCommon };
    break;

  case "recette":
    conf = { ...configRecette, ...configCommon };
    break;

  case "staging":
    conf = { ...configStaging, ...configCommon };
    break;

  case "production":
    conf = { ...configProd, ...configCommon };
    break;

  default:
    throw new Error("Env " + process.env.NODE_ENV + " is not an accepted value.");
}

const config = conf;

export default config;
